import vmClient from 'app/services/vmClient';
import { UserProfile, IUserProfile } from 'app/constants/schemas/UserProfile';
import { Room, IRoom } from 'app/constants/schemas/rtc/Room';
import { Entity, IEntityType, IEntity, EntityStringId } from 'app/types/entity';
import { DateMarshaller } from 'app/constants/schemas/Date';
import { BrandReference, IBrandReference } from 'app/constants/schemas/BrandReference';

export interface IMeetingBooking extends IEntity {
  attributes: {
    id: EntityStringId;
    open: boolean;
    createdAt: Date;
  };
  associations: {
    creator: IUserProfile | null;
    rtcRoom: IRoom | null;
    brand: IBrandReference | null;
  };
}

export type MeetingBooking = Entity<IMeetingBooking>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MeetingBooking: IEntityType<IMeetingBooking> = vmClient.defineClass({
  typeName: 'MeetingBooking',
  version:  4,
  persisted: true,

  attributes: {
    open: {
      type: 'boolean',
      notNull: true,
    },
    createdAt: {
      type: Date,
      notNull: true,
      marshaller: DateMarshaller,
    },
  },
  associations: {
    creator:  {
      type:   UserProfile,
      shared: true,
    },
    rtcRoom: { type: Room },
    brand: {
      type: BrandReference,
      shared: true,
    },
  },
});
